export namespace Image {
  export const Names: {
    'Empty Mailbox': 'Empty Mailbox.webp';
    'Empty Cart': 'Empty Cart.webp';
    'Empty': 'Empty.png';
    'Dashboard Empty': 'Dashboard Empty.webp';
    'Add User': 'Add User.webp';
    'Add Media': 'Add Media.webp';
    'Calendar Empty': 'Calendar Empty.webp';
    'Add Files': 'Add Files.webp';
    'Email Sent': 'Email Sent.webp';
    'Empty Inbox': 'Empty Inbox.webp';
    'No Email': 'No Email.webp';
    'Report Empty': 'Report Empty.webp';
    'Search Not Found': 'Search Not Found.webp';
    'Upload File': 'Upload File.webp';
    'Empty Folder': 'Empty Folder.webp';
    'General Files': 'General Files.webp';
    'Photos Add': 'Photos Add.webp';
    'Multiple User': 'Multiple User.webp';
    'No Files Cloud': 'No Files Cloud.webp';
    'No Location': 'No Location.webp';
    'No Notification': 'No Notification.webp';
    '404 Page Not Found': '404 Page Not Found.webp';
    'Cards': 'Cards.webp';
    'Content Lock': 'Content Lock.webp';
    'Empty Message': 'Empty Message.webp';
    'File Broken or Not Found': 'File Broken or Not Found.webp';
    'Multiple Message': 'Multiple Message.webp';
    'No Tasks': 'No Tasks.webp';
    'Nothing Here': 'Nothing Here.webp';
    'Something Went Wrong': 'Something Went Wrong.webp';
    'Task Done': 'Task Done.webp';
    'Trash Empty': 'Trash Empty.webp';
    'Under Maintenance': 'Under Maintenance.webp';
    'Upload Cloud': 'Upload Cloud.webp';
    'Vacation': 'Vacation.webp';
    'Wallet Empty': 'Wallet Empty.webp';
  } = {
    'Empty Mailbox': 'Empty Mailbox.webp',
    'Empty Cart': 'Empty Cart.webp',
    'Empty': 'Empty.png',
    'Dashboard Empty': 'Dashboard Empty.webp',
    'Add User': 'Add User.webp',
    'Add Media': 'Add Media.webp',
    'Calendar Empty': 'Calendar Empty.webp',
    'Add Files': 'Add Files.webp',
    'Email Sent': 'Email Sent.webp',
    'Empty Inbox': 'Empty Inbox.webp',
    'No Email': 'No Email.webp',
    'Report Empty': 'Report Empty.webp',
    'Search Not Found': 'Search Not Found.webp',
    'Upload File': 'Upload File.webp',
    'Empty Folder': 'Empty Folder.webp',
    'General Files': 'General Files.webp',
    'Photos Add': 'Photos Add.webp',
    'Multiple User': 'Multiple User.webp',
    'No Files Cloud': 'No Files Cloud.webp',
    'No Location': 'No Location.webp',
    'No Notification': 'No Notification.webp',
    '404 Page Not Found': '404 Page Not Found.webp',
    'Cards': 'Cards.webp',
    'Content Lock': 'Content Lock.webp',
    'Empty Message': 'Empty Message.webp',
    'File Broken or Not Found': 'File Broken or Not Found.webp',
    'Multiple Message': 'Multiple Message.webp',
    'No Tasks': 'No Tasks.webp',
    'Nothing Here': 'Nothing Here.webp',
    'Something Went Wrong': 'Something Went Wrong.webp',
    'Task Done': 'Task Done.webp',
    'Trash Empty': 'Trash Empty.webp',
    'Under Maintenance': 'Under Maintenance.webp',
    'Upload Cloud': 'Upload Cloud.webp',
    'Vacation': 'Vacation.webp',
    'Wallet Empty': 'Wallet Empty.webp',
  };

  export type Names = (typeof Names)[keyof typeof Names];
}
